import { type Dispatch, type SetStateAction, useMemo } from "react"

import { useSessionStorage } from "react-use"

import { type TUserState, useUser } from "@/3514/hooks/use-user"
import { EUserRole } from "@/3514/types"
import { SessionStorageServiceKeys } from "@/services"

function useIsFakeParticipant(): boolean {
    const [isFakeParticipantFeatureEnabled]: [boolean, Dispatch<SetStateAction<boolean>>] = useSessionStorage<boolean>(
        SessionStorageServiceKeys.FakeParticipantsFeatureEnabled(),
        false
    )

    const { user, isLoaded: isUserLoaded }: TUserState<EUserRole.Participant> = useUser<EUserRole.Participant>()

    return useMemo(
        (): boolean => isFakeParticipantFeatureEnabled && isUserLoaded && user.isSubUser,
        [isFakeParticipantFeatureEnabled, isUserLoaded, user]
    )
}

export { useIsFakeParticipant }
